import React from 'react';
import { useTranslation } from 'react-i18next';
import { Download } from '../../../_lib/components/Download/Download';
import { Icons, SVG } from '../../atoms/SVG';
import { Hyperlink } from '../../atoms/Hyperlink';
import { Namespace } from '../../../translation/namespace';
import { getDisplayName, IFileItemSearch } from '../../../types/api/FileItem';
import IUrl from '../../../types/IUrl';
import { removeHighlightingTags, TextMarker } from '../../../_lib/components/TextMarker/TextMarker';

type ContentAttachmentList = {
  attachments: IFileItemSearch[];
  hasMoreAttachments?: boolean;
  moreAttachmentsUrl?: IUrl;
  useTextMarker?: boolean;
};

/**
 * A listing of attached content.
 */
export function ContentAttachmentList({
  attachments,
  moreAttachmentsUrl,
  hasMoreAttachments,
  useTextMarker = false,
}: ContentAttachmentList) {
  const { t } = useTranslation(Namespace.ContentAttachmentList);

  // This condition prevents empty ul
  if (attachments.length === 0) {
    return null;
  }

  return (
    <>
      <ul className="content-attachment-list" aria-label={t('invisibleTitle')}>
        {attachments.map(attachment => (
          <li className="content-attachment-list__item" key={attachment.url?.url}>
            {useTextMarker ? (
              <Download
                {...attachment}
                fileName={removeHighlightingTags(attachment.fileName)}
                fileTitle={attachment.fileTitle && removeHighlightingTags(attachment.fileTitle)}
                url={attachment.url?.url}
              >
                <TextMarker text={getDisplayName(attachment.fileName, attachment.fileTitle)} />
              </Download>
            ) : (
              <Download {...attachment} url={attachment.url?.url} />
            )}
          </li>
        ))}
      </ul>
      {hasMoreAttachments && moreAttachmentsUrl && (
        <Hyperlink className="content-attachment-list__attachments-more-link" to={moreAttachmentsUrl.url}>
          <span className="content-attachment-list__attachments-icon-container">
            <SVG svgSpriteId={Icons.INTERNAL_LINK_ARROW} />
          </span>
          {t('hasMoreAttachments')}
        </Hyperlink>
      )}
    </>
  );
}
